import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import CookieConsent from 'react-cookie-consent';
import ReactGA from 'react-ga';
import useDataStore from '../Data/dataStore';
import { API } from '../globalUtils';
import { sanitize } from '../../utils';
const GDPR = () => {
    const setup = useDataStore((state) => state.data[API.setup]);
    // track whether GA was initialized
    const [gaInitialized, setGaInitialized] = useState(false);
    const location = useLocation();
    const handleAccept = useCallback(() => {
        if (setup.gdpr_tracking_code) {
            ReactGA.initialize(setup.gdpr_tracking_code);
            ReactGA.pageview(window.location.pathname + window.location.search);
            setGaInitialized(true);
        }
    }, [setup?.gdpr_tracking_code]);
    // on every client-side route change, send a pageview if GA is active
    useEffect(() => {
        if (gaInitialized) {
            ReactGA.pageview(location.pathname + location.search);
        }
    }, [location, gaInitialized]);
    if (!setup) {
        return null;
    }
    const { gdpr_agree, gdpr_decline, gdpr_text } = setup;
    return (_jsx(CookieConsent, { location: "bottom", buttonText: gdpr_agree, declineButtonText: gdpr_decline, cookieName: "gaConsent", enableDeclineButton: true, onAccept: handleAccept, expires: 150, style: {
            background: 'var(--fontColor)',
            color: 'var(--backgroundColor)',
        }, buttonClasses: "button gdpr-button", declineButtonClasses: "button gdpr-button decline-button", containerClasses: "gdpr-container", buttonWrapperClasses: "gdpr-buttons", children: _jsx("div", { className: "gdpr-text", dangerouslySetInnerHTML: {
                __html: sanitize(gdpr_text),
            } }) }));
};
export default GDPR;
